import React from "react"
import "./DiscoveryCTA.css"

const DiscoveryCTA = () => {
  const scrollToBooking = () => {
    const element = document.getElementById("booking-form")
    const headerOffset = 80
    const elementPosition = element ? element.offsetTop : 0
    const offsetPosition = elementPosition - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  return (
    <section className='discovery-cta section section-green'>
      <div className='container'>
        <div className='cta-inner animate-fade-up'>
          <h2 className='section-title'>
            Ready to Launch Your Own Staffing Business?
          </h2>
          <p className='cta-description'>
            Our franchise discovery process helps you explore ownership
            potential, territory options, and next-step timelines — no pressure,
            no fluff.
          </p>
          <button className='btn-primary' onClick={scrollToBooking}>
            Book My Franchise Discovery Call
          </button>
        </div>
      </div>
    </section>
  )
}

export default DiscoveryCTA

